import { atom } from 'recoil';
export var boxesState = atom({
    key: 'boxes',
    default: [
        {
            name: 'box',
        },
    ],
});
